export default {
  phone: /1\d{10}/,
  telephone: /[0-9-()（）]{7,18}/,
  identityCard:
    /^\d{6}(18|19|20)?\d{2}(0[1-9]|1[012])(0[1-9]|[12]\d|3[01])\d{3}(\d|X)$/i,
  taxNum: /^[A-Z0-9]{15}$|^[A-Z0-9]{18}$|^[A-Z0-9]{20}$/,
  number: /\d+/,
  integer: /^[1-9]\d*$/,
  email: /^([\w.-]+)@([\da-z.-]+)\.([a-z.]{2,6})$/i,
  lawyerCardNum: /\d{17}/,
};
